import React, { Suspense } from 'react';
import { useFeatureFlag } from '@sparknz/feature-flags';
import {
  ErrorBoundary,
  GenericErrorText,
  LoginModalProvider,
} from '@sparknz/journeys-common';
import { SnackbarProvider } from '@sparknz/spark-pattern-library';
import {
  SparkComponentLibrary,
  UniversalLoginProvider,
} from '@sparknz/universal-login-library';

import { EditorModePlaceholder } from 'shared/components';
import { CaptchaProvider, usePageConfig } from 'shared/providers';
import PlansContentLoader from '../MobilePlans/components/PlansContentLoader';
import { QueryParameterKey } from '../MobilePlans/constants/query.constants';
import Plans from '../shared/components/Plans';
import { CategorySelectionProvider } from '../shared/providers';
import { Category } from '../shared/typings/product';
import { TravelPacksProps } from './TravelPacksEditConfig';

const travelPacksCategory: Category = { id: 'travel-pack', name: '' };

export default function TravelPacks({ isInEditor }: TravelPacksProps) {
  const { apiBaseUrl, hCaptchaKey } = usePageConfig();

  const config = {
    apiBaseURL: apiBaseUrl,
    brand: 'Spark',
    reCaptchaKey: '',
    hCaptchaKey: hCaptchaKey,
    name: '',
    isZeroRatingEnabled: true,
    fallbackURL: window.location.origin,
    trackingScriptURL: '',
    host: '',
  };

  const { value } = useFeatureFlag('release-enable-forgerock-login-modal');

  return isInEditor ? (
    <EditorModePlaceholder label="Travel Packs component in editor mode" />
  ) : (
    <ErrorBoundary fallback={GenericErrorText}>
      <SnackbarProvider>
        <CaptchaProvider>
          <Suspense fallback={<PlansContentLoader />}>
            <UniversalLoginProvider
              config={config}
              componentLibrary={SparkComponentLibrary}
            >
              <LoginModalProvider useForgerock={value}>
                <CategorySelectionProvider
                  categories={[travelPacksCategory]}
                  categoryQueryKey={QueryParameterKey.Category}
                  subCategoryQueryKey={QueryParameterKey.Subcategory}
                >
                  <Plans />
                </CategorySelectionProvider>
              </LoginModalProvider>
            </UniversalLoginProvider>
          </Suspense>
        </CaptchaProvider>
      </SnackbarProvider>
    </ErrorBoundary>
  );
}
